import React from 'react';
import isReactFragment from "utils/isReactFragment";
import { Menu } from "@headlessui/react";
import { ReactComponent as IconNav } from "assets/images/icons/project-icons/dots-h.svg";
import { ReactComponent as IconCaretDropdownIndicator } from "assets/images/icons/project-icons/caret-dropdown-indicator.svg";


const Dropdown = (props) => {
    // console.log(props.children[0].type);
    // console.log(isReactFragment(props.children[0].type) ? "a" : "b");

    return (
        <Menu as="div" className="">

            <Menu.Items>
                <Menu.Item>
                    <div className="w-screen h-screen fixed inset-0 z-[9999] bg-black opacity-20"></div>
                </Menu.Item>
            </Menu.Items>
            
            <div className={"dropdownNew group inline-block " + props.className}>
                <Menu.Button as="div" className={`cursor-pointer ${props.flipSwitch && "rotate-90"}`}>
                    {(isReactFragment(props.children[0].type)) &&
                        <IconNav style={{ height: "26px" }} className={`w-8 px-1.5 py-0.5 relative cursor-pointer group-hover:bg-gray-300 rounded ${props.iconClassName}`} />
                    }

                    {!(isReactFragment(props.children[0].type)) &&
                        props.children[0]
                    }
                </Menu.Button>

                <Menu.Items>
                    <div className="w-4 h-2 sm:mr-2 absolute z-[9999] right-16 sm:right-20">
                        <IconCaretDropdownIndicator className="w-full h-2" />
                    </div>
                </Menu.Items>

                <Menu.Items as="div" className="mt-2 dropdown z-[9999]">
                    <div className="dropdown-content">
                        <Menu.Item>
                            {(props.children) ? props.children[1] : ""}
                        </Menu.Item>
                    </div>
                </Menu.Items>
            </div>

        </Menu>
    );
};

export default Dropdown;